import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import {
    validateContactNo,
    validateEmail,
    validatePostalCode,
} from "../../common/validation";
import { post } from 'jquery';
import SideMenu from '../../components/side-menu/SideMenu';
import MyStorage from '../../common/MyStorage';
import Loader from "react-loader-spinner";
import { Link } from 'react-router-dom'
import {
    UpdateCartCount,
    UpdateCartAmount
} from "../../redux/actions/postActions";
function Address(props) {
    const [givenName, setGivenName] = useState('')
    const [addressFromProps, setAddressFromProps] = useState<any>([])
    const [name, setName] = useState('')
    const [noName, setNoName] = useState(false)
    const [address1, setAddress1] = useState('')
    const [noAddress, setNoAddress] = useState(false)
    const [address2, setAddress2] = useState('')
    const [emailID, setEmailID] = useState('')
    const [noEmail, setNoEmail] = useState(false)
    const [show_email_error, set_show_email_error] = useState(false)
    const [mobile, setMobile] = useState('')
    const [noMobile, setNoMobile] = useState(false)
    const [show_phone_error, set_show_phone_error] = useState(false)
    const [show_postal_error, set_show_postal_error] = useState(false)
    const [postal, setPostal] = useState('')
    const [nopostal, setNoPostal] = useState(false)
    const [is_loading, setIsLoading] = useState(false)
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const fullNameRef = useRef<any>();
    const emailRef = useRef<any>();
    const mobileRef = useRef<any>();
    const address1Ref = useRef<any>();
    const postalCodeRef = useRef<any>();




    useEffect(() => {
        const storage = new MyStorage()
        const token = storage.getloggedIn()
        let _item = props?.location?.state?.item
        if (_item) {
            setEmailID(_item.contact_email)
            setName(_item.contact_name)
            setMobile(_item.contact_number)
            setPostal(_item.postal_code)
            setAddress1(_item.street_name)
            setAddress2(_item.building_name)
            setAddressFromProps(_item)
        }
        if (token == "true") {
            console.log("Auth Token", token)
            const given_name = storage.getName()?.split(' ')[0];
            setGivenName(given_name ? given_name : '')
        } else {
            props?.history?.push('/login', { from: 'Add Address' })
        }
        if (props?.history?.location) {
            window.scrollTo(0, 0)
        }
        if (props?.location?.state?.zeroAddress) { prefillData() }
    }, [])
    useEffect(() => {
        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                event.preventDefault();
                if (props?.location?.state?.editAddress) {
                    updateAddress(event)
                } else {
                    addAddress(event)
                }
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
        };
    }, [name, emailID, mobile, address1, postal]);

    const prefillData = async () => {
        const storage = new MyStorage()
        const userID = storage.getUserId()
        if(userID){
            new WebApiCalls()
            .getUserInfo(userID)
            .then((response) => {
                setEmail(response.Email)
                setPhone(response.PhoneNumber)
                let name: any =  storage.getName();
                // let phoneNumber: any = await storage.getPhoneNumber();
                // let Email: any = await storage.getEmailFrasers();
                    let temp_obj = {
                        contact_name: name,
                        contact_number: response.PhoneNumber,
                        contact_email: response.Email,
                    }
                    setName(name)
                    setMobile(response.PhoneNumber)
                    setEmailID(response.Email)
                    setAddressFromProps(temp_obj) 
            });
        }
    }
    const handleEmailInput = (event) => {
        setEmailID(event.target.value)
        setNoEmail(false)
        let valid = validateEmail(event.target.value);
        set_show_email_error(!valid)
        if (show_email_error) {
            emailRef.current.focus();
        }

    };
    const handleNameInput = (event) => {
        if (event.target.value.length > 0) {
            setName(event.target.value)
            setNoName(false)
        } else {
            setName(event.target.value)
            setNoName(true)
            fullNameRef.current.focus();
        }
    }
    const handleAddressInput = (event) => {
        if (event.target.value.length > 0) {
            setAddress1(event.target.value)
            setNoAddress(false)
        } else {
            setAddress1(event.target.value)
            setNoAddress(true)
            address1Ref.current.focus();
        }
    }
    const handlePhoneInput = (event) => {
        setMobile(event.target.value)
        setNoMobile(false)
        let valid = validateContactNo(event.target.value);
        set_show_phone_error(!valid)
        if (!noMobile) {
            mobileRef.current.focus()
        }
    };
    const handlePostalInput = (event) => {
        setPostal(event.target.value)
        setNoPostal(false)
        let valid = validatePostalCode(event.target.value)
        set_show_postal_error(!valid)
        if (show_postal_error) {
            postalCodeRef.current.focus()
        }
    };
    const addAddress = async (e) => {
        e.preventDefault();
        const storage = new MyStorage()

        const contactId = storage.getContactIDFrasers();
        // const email = storage.getEmailFrasers();
        const authentication = storage.getauthenticationFrasers();
        if (name == '') {
            setNoName(true)
            setIsLoading(false)
            fullNameRef.current.focus()

            return
        }
        if (emailID == '') {
            setNoEmail(true)
            emailRef.current.focus()
            setIsLoading(false)
            return
        }
        if (mobile == '') {
            setNoMobile(true)
            mobileRef.current.focus()
            setIsLoading(false)
            return
        }
        if (address1 == '') {
            setNoAddress(true)
            address1Ref.current.focus()
            setIsLoading(false)
            return
        }
        if (postal == '') {
            setNoPostal(true)
            postalCodeRef.current.focus()
            setIsLoading(false)
            return
        }

        let itemObj = {
            contact_email: emailID,
            contact_id: contactId,
            contact_name: name,
            contact_number: mobile,
            postal_code: postal,
            block_number: ' ',
            unit_number: ' ',
            street_name: address1,
            building_name: address2,
            country: "Singapore",
            is_default: "N",
        };
        if (show_email_error || show_phone_error || show_postal_error || noEmail || noMobile || noAddress || nopostal) {
            setIsLoading(false)
        }
        else {
            await new WebApiCalls()
                .addAddress(itemObj, authentication)
                .then((response) => {
                    let cart_id = new MyStorage().getCartID();
                    if (response.statusCode === 200) {
                        setIsLoading(false)
                        if (props?.location?.state?.comingFromCart) {
                            props?.history?.push(`/my-bag`)
                        } else {
                            props?.history?.push("/address-book", { from: 'Add Address' })
                        }
                    } else {
                        setIsLoading(false)
                        console.log(response.error)
                    }
                }).catch(e = () => {
                    setIsLoading(false)
                    console.log("Error: ", e)
                })
        }
    };
    const updateAddress = async (e) => {
        e.preventDefault();
        const storage = new MyStorage()

        const contactId = storage.getContactIDFrasers();
        // const email = storage.getEmailFrasers();
        const authentication = storage.getauthenticationFrasers();

        let itemObj = {
            address_id: addressFromProps?.address_id,
            contact_email: emailID ? emailID : addressFromProps?.contact_email,
            contact_id: contactId,
            contact_name: name ? name : addressFromProps?.contact_name,
            contact_number: mobile ? mobile : addressFromProps?.contact_number,
            postal_code: postal ? postal : addressFromProps?.postal_code,
            block_number: ' ',
            unit_number: ' ',
            street_name: address1 ? address1 : addressFromProps?.street_name,
            building_name: address2 ? address2 : addressFromProps?.building_name,
            country: "Singapore",
            is_default: "N",
        };
        if (show_email_error || show_phone_error || show_postal_error || noEmail || noMobile || noAddress || nopostal) {
            setIsLoading(false)
        }
        else {
            await new WebApiCalls()
                .updateAddress(itemObj, authentication)
                .then((response) => {
                    if (response.statusCode === 200) {
                        props?.history?.goBack()
                    } else {
                        console.log(response.error)
                    }
                });
        }
    };
    const ErrorView = (_text) => {
        return (<div className="error" style={{ display: "block", marginTop: 10 }}>{_text}</div>)
    }
    return (
        <div>
            <div className="viewport"></div>

            {/* /container */}
            <div className="container">

                {/* header */}
                <Header props={props} />
                {/* /header */}
                <MenuBar props={props} />
                {/* /content */}
                <div className="content">

                    {/* breadcrumb-back */}
                    <div className="breadcrumb-back">

                        {/* breadcrumb */}
                        <div className="breadcrumb">
                            <Link to="/">Home</Link>
                            <a href="#">Account</a>
                            <a onClick={() => { props?.history?.push("/address-book", { from: 'Add Address' }) }}>Address Book</a>
                            {props?.location?.state?.editAddress == true ?
                                <a onClick={() => { props?.history?.push("/address-book/add-address") }}>Edit Address</a>
                                :
                                <a onClick={() => { props?.history?.push("/address-book/add-address") }}>Add New Address</a>
                            }
                        </div>
                        {/* /breadcrumb */}

                        <a onClick={() => { props?.history?.goBack() }} className="backbtn">BACK</a>

                    </div>
                    {/* /breadcrumb-back */}

                    {/* product listing */}
                    <div className="account-page">

                        {/* two-columns */}
                        <div className="two-columns">

                            {/* left panel */}
                            <SideMenu props={props} />
                            {/* /left panel */}

                            {/* /right panel */}
                            <div className="right-panel">

                                {/* address book */}
                                <div className="address-book">
                                    {/* add address */}
                                    <div className="add-address">

                                        <form>

                                            <fieldset>
                                                <label htmlFor="">FULL NAME*</label>
                                                <input type="text" name="fullname" id="fullname" onChange={handleNameInput}
                                                    defaultValue={addressFromProps?.contact_name}
                                                    value={name}
                                                    ref={fullNameRef} />
                                                {noName == true &&
                                                    ErrorView("Please enter full name")
                                                }
                                            </fieldset>

                                            <fieldset>
                                                <label htmlFor="">EMAIL ADDRESS*</label>
                                                <input type="text" name="email" id="email" onChange={handleEmailInput}
                                                    defaultValue={addressFromProps?.contact_email}
                                                    value={emailID}
                                                    ref={emailRef} />
                                                {noEmail == true &&
                                                    ErrorView("Please enter email address")}
                                                {show_email_error == true &&
                                                    ErrorView("This does not look like a valid email address")}
                                            </fieldset>

                                            <fieldset>
                                                <label htmlFor="">MOBILE NO.*</label>
                                                <input type="text" name="mobileno" id="mobileno" onChange={handlePhoneInput}
                                                    defaultValue={addressFromProps?.contact_number}
                                                    value={mobile}
                                                    ref={mobileRef} />
                                                {noMobile == true &&
                                                    ErrorView("Please enter mobile number")}
                                                {show_phone_error == true &&
                                                    ErrorView("This does not look like a valid mobile number")}
                                            </fieldset>

                                            <fieldset>
                                                <label htmlFor="">ADDRESS 1*</label>
                                                <input type="text" name="address1" id="address1" onChange={handleAddressInput}
                                                    defaultValue={addressFromProps?.street_name}
                                                    value={address1}
                                                    ref={address1Ref} />
                                                {noAddress == true &&
                                                    ErrorView("Please enter address 1")}
                                            </fieldset>

                                            <fieldset>
                                                <label htmlFor="">ADDRESS 2</label>
                                                <input type="text" name="address2" id="address2" onChange={(e) => setAddress2(e.target.value)}
                                                    defaultValue={addressFromProps?.building_name}
                                                    value={address2}
                                                />
                                            </fieldset>

                                            <fieldset>
                                                <label htmlFor="">POSTAL CODE*</label>
                                                <input type="text" name="postal" id="postal" onChange={handlePostalInput}
                                                    defaultValue={addressFromProps?.postal_code}
                                                    value={postal}
                                                    ref={postalCodeRef} />
                                                {nopostal == true &&
                                                    ErrorView("Please enter postal code")}
                                                {show_postal_error == true &&
                                                    ErrorView("This does not look like a valid postal code")}
                                            </fieldset>

                                            <fieldset>
                                                <label htmlFor="">COUNTRY</label>
                                                Singapore
                                            </fieldset>

                                            <fieldset>
                                                <a className="blackbutton" onClick={(e) => {
                                                    setIsLoading(true)
                                                    if (props?.location?.state?.editAddress) {
                                                        updateAddress(e)
                                                    } else {
                                                        addAddress(e)
                                                    }
                                                }}>
                                                    {
                                                        is_loading ?
                                                            <Loader
                                                                type="TailSpin"
                                                                color="white"
                                                                height={18}
                                                                width={18}
                                                            />
                                                            :
                                                            "SAVE"}
                                                </a>
                                                <a onClick={() => {
                                                    props?.history?.push("/address-book", { from: 'Add Address' })
                                                }}>Cancel</a>
                                            </fieldset>

                                        </form>

                                    </div>
                                    {/* /add address */}

                                </div>
                                {/* /address-book */}

                            </div>
                            {/* /right panel */}

                        </div>
                        {/* /two-columns */}

                    </div>
                    {/* /product listing */}

                </div>
                {/* /content*/}


            </div>

            <Footer props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>


        </div>
    )
}
const mapStateToProps = (state) => {
    const { cart_count,allCategories } = state.UserReducer
    return { cart_count,allCategories }
};
const actions = {
    UpdateCartCount,
    UpdateCartAmount
};
export default connect(mapStateToProps, actions)(Address);